import { render, staticRenderFns } from "./ContestEntryComplete.vue?vue&type=template&id=2c552f8a&scoped=true"
import script from "./ContestEntryComplete.vue?vue&type=script&lang=ts"
export * from "./ContestEntryComplete.vue?vue&type=script&lang=ts"
import style0 from "./ContestEntryComplete.vue?vue&type=style&index=0&id=2c552f8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c552f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c552f8a')) {
      api.createRecord('2c552f8a', component.options)
    } else {
      api.reload('2c552f8a', component.options)
    }
    module.hot.accept("./ContestEntryComplete.vue?vue&type=template&id=2c552f8a&scoped=true", function () {
      api.rerender('2c552f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/event/ContestEntryComplete.vue"
export default component.exports